import { render, staticRenderFns } from "./CertificationInfo.vue?vue&type=template&id=60056e54&scoped=true&"
import script from "./CertificationInfo.vue?vue&type=script&lang=ts&"
export * from "./CertificationInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60056e54",
  null
  
)

export default component.exports